export const environment = {
  production: false,
  environment: 'development',
  apiUrl: 'https://mareauto-qa.ditech.es',
  enableLogging: true,
  version: '1.0.0-dev',
};
